import { Box, Typography, styled } from '@mui/material';

export const Field = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 4,
  width: 175,
});

export const FieldLabel = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '18px',
  color: '#768691',
});

export const compactContainerSx = {
  width: 'auto !important',
};

export const compactFiltersSx = {
  width: 'auto !important',
  marginBottom: '0 !important',
  gap: '8px !important',
  '& > div': {
    marginLeft: '0 !important',
  },
  '& .MuiAutocomplete-root': {
    minWidth: '175px !important',
  },
  '& .MuiAutocomplete-root .MuiOutlinedInput-root': {
    paddingRight: '0 !important',
  },
  '& .MuiAutocomplete-root.MuiAutocomplete-hasPopupIcon .MuiFormControl-root.MuiAutocomplete-inputRoot':
    {
      paddingRight: '0 !important',
    },
};
